import client from "./client";

// Use destructuring in the parameter to be explicit
export const createPaymentOrder = ({ competitionId, amount }) =>
  client
    .post("/payments/create-order", { competitionId, amount })
    .then((res) => res.data);

export const verifyPayment = (paymentData) =>
  client.post("/payments/verify", paymentData).then((res) => res.data);
